import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";


export var isVersionAdditionallyConfigured = function isVersionAdditionallyConfigured(portfolio, bcIndex) {var _portfolio$bcVersions;
  return ((_portfolio$bcVersions = portfolio.bcVersions[bcIndex]) === null || _portfolio$bcVersions === void 0 ? void 0 : _portfolio$bcVersions.additionalConfig) === 'true' || false;
};

// Defines total table width. This will be multiplied by 1 column width
export var getTotalColumnsAmount = function getTotalColumnsAmount(portfolios) {
  var columnsAmount = 0;

  portfolios.forEach(function (_ref) {var products = _ref.products;
    products.forEach(function (_ref2) {var bcDependentData = _ref2.bcDependentData;
      columnsAmount += _Object$keys(bcDependentData).length;
    });
  });
  return columnsAmount;
};

// Defines total portfolio width. This will be multiplied by 1 column width
export var getPortfolioColumnsAmount = function getPortfolioColumnsAmount(portfolio) {
  var columnsAmount = 0;

  portfolio.products.forEach(function (_ref3) {var bcDependentData = _ref3.bcDependentData;
    columnsAmount += _Object$keys(bcDependentData).length;
  });

  return columnsAmount;
};

// Filter portfolios by product line
export var filterByPlId = function filterByPlId(
portfolios,
productLineId)
{
  return _filterInstanceProperty(portfolios).call(portfolios, function (portfolio) {return portfolio.productLineId === productLineId;});
};

export var isVariantPredefined = function isVariantPredefined(cartItem, bcIndex) {var _cartItem$browsingCri;
  return typeof (cartItem === null || cartItem === void 0 ? void 0 : (_cartItem$browsingCri = cartItem.browsingCriteria[bcIndex]) === null || _cartItem$browsingCri === void 0 ? void 0 : _cartItem$browsingCri.added) === 'boolean';
};

export var isVariantAddedToCart = function isVariantAddedToCart(cartItem, bcIndex) {var _cartItem$browsingCri2;
  var predefinedValue = isVariantPredefined(cartItem, bcIndex);
  // Added property shows that the status was set manually in a project to display correct shortNames after removing
  var addedManually = predefinedValue ? cartItem === null || cartItem === void 0 ? void 0 : (_cartItem$browsingCri2 = cartItem.browsingCriteria[bcIndex]) === null || _cartItem$browsingCri2 === void 0 ? void 0 : _cartItem$browsingCri2.added : null;

  return predefinedValue ? !!addedManually : !!(cartItem !== null && cartItem !== void 0 && cartItem.browsingCriteria[bcIndex]);
};
//# sourceMappingURL=utils.js.map